// countries.js
const countries = [
  { name: 'Afghanistan', code: 'af', dialCode: '+93', flag: 'https://flagcdn.com/af.svg' },
  { name: 'Albania', code: 'al', dialCode: '+355', flag: 'https://flagcdn.com/al.svg' },
  { name: 'Algeria', code: 'dz', dialCode: '+213', flag: 'https://flagcdn.com/dz.svg' },
  { name: 'Andorra', code: 'ad', dialCode: '+376', flag: 'https://flagcdn.com/ad.svg' },
  { name: 'Angola', code: 'ao', dialCode: '+244', flag: 'https://flagcdn.com/ao.svg' },
  {
    name: 'Antigua and Barbuda',
    code: 'ag',
    dialCode: '+1268',
    flag: 'https://flagcdn.com/ag.svg',
  },
  { name: 'Argentina', code: 'ar', dialCode: '+54', flag: 'https://flagcdn.com/ar.svg' },
  { name: 'Armenia', code: 'am', dialCode: '+374', flag: 'https://flagcdn.com/am.svg' },
  { name: 'Australia', code: 'au', dialCode: '+61', flag: 'https://flagcdn.com/au.svg' },
  { name: 'Austria', code: 'at', dialCode: '+43', flag: 'https://flagcdn.com/at.svg' },
  { name: 'Azerbaijan', code: 'az', dialCode: '+994', flag: 'https://flagcdn.com/az.svg' },
  { name: 'Bahamas', code: 'bs', dialCode: '+1242', flag: 'https://flagcdn.com/bs.svg' },
  { name: 'Bahrain', code: 'bh', dialCode: '+973', flag: 'https://flagcdn.com/bh.svg' },
  { name: 'Bangladesh', code: 'bd', dialCode: '+880', flag: 'https://flagcdn.com/bd.svg' },
  { name: 'Barbados', code: 'bb', dialCode: '+1246', flag: 'https://flagcdn.com/bb.svg' },
  { name: 'Belarus', code: 'by', dialCode: '+375', flag: 'https://flagcdn.com/by.svg' },
  { name: 'Belgium', code: 'be', dialCode: '+32', flag: 'https://flagcdn.com/be.svg' },
  { name: 'Belize', code: 'bz', dialCode: '+501', flag: 'https://flagcdn.com/bz.svg' },
  { name: 'Benin', code: 'bj', dialCode: '+229', flag: 'https://flagcdn.com/bj.svg' },
  { name: 'Bhutan', code: 'bt', dialCode: '+975', flag: 'https://flagcdn.com/bt.svg' },
  { name: 'Bolivia', code: 'bo', dialCode: '+591', flag: 'https://flagcdn.com/bo.svg' },
  {
    name: 'Bosnia and Herzegovina',
    code: 'ba',
    dialCode: '+387',
    flag: 'https://flagcdn.com/ba.svg',
  },
  { name: 'Botswana', code: 'bw', dialCode: '+267', flag: 'https://flagcdn.com/bw.svg' },
  { name: 'Brazil', code: 'br', dialCode: '+55', flag: 'https://flagcdn.com/br.svg' },
  { name: 'Brunei', code: 'bn', dialCode: '+673', flag: 'https://flagcdn.com/bn.svg' },
  { name: 'Bulgaria', code: 'bg', dialCode: '+359', flag: 'https://flagcdn.com/bg.svg' },
  { name: 'Burkina Faso', code: 'bf', dialCode: '+226', flag: 'https://flagcdn.com/bf.svg' },
  { name: 'Burundi', code: 'bi', dialCode: '+257', flag: 'https://flagcdn.com/bi.svg' },
  { name: 'Cabo Verde', code: 'cv', dialCode: '+238', flag: 'https://flagcdn.com/cv.svg' },
  { name: 'Cambodia', code: 'kh', dialCode: '+855', flag: 'https://flagcdn.com/kh.svg' },
  { name: 'Cameroon', code: 'cm', dialCode: '+237', flag: 'https://flagcdn.com/cm.svg' },
  { name: 'Canada', code: 'ca', dialCode: '+1', flag: 'https://flagcdn.com/ca.svg' },
  {
    name: 'Central African Republic',
    code: 'cf',
    dialCode: '+236',
    flag: 'https://flagcdn.com/cf.svg',
  },
  { name: 'Chad', code: 'td', dialCode: '+235', flag: 'https://flagcdn.com/td.svg' },
  { name: 'Chile', code: 'cl', dialCode: '+56', flag: 'https://flagcdn.com/cl.svg' },
  { name: 'China', code: 'cn', dialCode: '+86', flag: 'https://flagcdn.com/cn.svg' },
  { name: 'Colombia', code: 'co', dialCode: '+57', flag: 'https://flagcdn.com/co.svg' },
  { name: 'Comoros', code: 'km', dialCode: '+269', flag: 'https://flagcdn.com/km.svg' },
  { name: 'Congo', code: 'cg', dialCode: '+242', flag: 'https://flagcdn.com/cg.svg' },
  { name: 'Costa Rica', code: 'cr', dialCode: '+506', flag: 'https://flagcdn.com/cr.svg' },
  { name: "Côte d'Ivoire", code: 'ci', dialCode: '+225', flag: 'https://flagcdn.com/ci.svg' },
  { name: 'Croatia', code: 'hr', dialCode: '+385', flag: 'https://flagcdn.com/hr.svg' },
  { name: 'Cuba', code: 'cu', dialCode: '+53', flag: 'https://flagcdn.com/cu.svg' },
  { name: 'Cyprus', code: 'cy', dialCode: '+357', flag: 'https://flagcdn.com/cy.svg' },
  { name: 'Czech Republic', code: 'cz', dialCode: '+420', flag: 'https://flagcdn.com/cz.svg' },
  { name: 'Denmark', code: 'dk', dialCode: '+45', flag: 'https://flagcdn.com/dk.svg' },
  { name: 'Djibouti', code: 'dj', dialCode: '+253', flag: 'https://flagcdn.com/dj.svg' },
  { name: 'Dominica', code: 'dm', dialCode: '+1767', flag: 'https://flagcdn.com/dm.svg' },
  { name: 'Dominican Republic', code: 'do', dialCode: '+1849', flag: 'https://flagcdn.com/do.svg' },
  { name: 'East Timor', code: 'tl', dialCode: '+670', flag: 'https://flagcdn.com/tl.svg' },
  { name: 'Ecuador', code: 'ec', dialCode: '+593', flag: 'https://flagcdn.com/ec.svg' },
  { name: 'Egypt', code: 'eg', dialCode: '+20', flag: 'https://flagcdn.com/eg.svg' },
  { name: 'El Salvador', code: 'sv', dialCode: '+503', flag: 'https://flagcdn.com/sv.svg' },
  { name: 'Equatorial Guinea', code: 'gq', dialCode: '+240', flag: 'https://flagcdn.com/gq.svg' },
  { name: 'Eritrea', code: 'er', dialCode: '+291', flag: 'https://flagcdn.com/er.svg' },
  { name: 'Estonia', code: 'ee', dialCode: '+372', flag: 'https://flagcdn.com/ee.svg' },
  { name: 'Eswatini', code: 'sz', dialCode: '+268', flag: 'https://flagcdn.com/sz.svg' },
  { name: 'Ethiopia', code: 'et', dialCode: '+251', flag: 'https://flagcdn.com/et.svg' },
  { name: 'Fiji', code: 'fj', dialCode: '+679', flag: 'https://flagcdn.com/fj.svg' },
  { name: 'Finland', code: 'fi', dialCode: '+358', flag: 'https://flagcdn.com/fi.svg' },
  { name: 'France', code: 'fr', dialCode: '+33', flag: 'https://flagcdn.com/fr.svg' },
  { name: 'Gabon', code: 'ga', dialCode: '+241', flag: 'https://flagcdn.com/ga.svg' },
  { name: 'Gambia', code: 'gm', dialCode: '+220', flag: 'https://flagcdn.com/gm.svg' },
  { name: 'Georgia', code: 'ge', dialCode: '+995', flag: 'https://flagcdn.com/ge.svg' },
  { name: 'Germany', code: 'de', dialCode: '+49', flag: 'https://flagcdn.com/de.svg' },
  { name: 'Ghana', code: 'gh', dialCode: '+233', flag: 'https://flagcdn.com/gh.svg' },
  { name: 'Greece', code: 'gr', dialCode: '+30', flag: 'https://flagcdn.com/gr.svg' },
  { name: 'Grenada', code: 'gd', dialCode: '+1473', flag: 'https://flagcdn.com/gd.svg' },
  { name: 'Guatemala', code: 'gt', dialCode: '+502', flag: 'https://flagcdn.com/gt.svg' },
  { name: 'Guinea', code: 'gn', dialCode: '+224', flag: 'https://flagcdn.com/gn.svg' },
  { name: 'Guinea-Bissau', code: 'gw', dialCode: '+245', flag: 'https://flagcdn.com/gw.svg' },
  { name: 'Guyana', code: 'gy', dialCode: '+592', flag: 'https://flagcdn.com/gy.svg' },
  { name: 'Haiti', code: 'ht', dialCode: '+509', flag: 'https://flagcdn.com/ht.svg' },
  { name: 'Honduras', code: 'hn', dialCode: '+504', flag: 'https://flagcdn.com/hn.svg' },
  { name: 'Hungary', code: 'hu', dialCode: '+36', flag: 'https://flagcdn.com/hu.svg' },
  { name: 'Iceland', code: 'is', dialCode: '+354', flag: 'https://flagcdn.com/is.svg' },
  { name: 'India', code: 'in', dialCode: '+91', flag: 'https://flagcdn.com/in.svg' },
  { name: 'Indonesia', code: 'id', dialCode: '+62', flag: 'https://flagcdn.com/id.svg' },
  { name: 'Iran', code: 'ir', dialCode: '+98', flag: 'https://flagcdn.com/ir.svg' },
  { name: 'Iraq', code: 'iq', dialCode: '+964', flag: 'https://flagcdn.com/iq.svg' },
  { name: 'Ireland', code: 'ie', dialCode: '+353', flag: 'https://flagcdn.com/ie.svg' },
  { name: 'Israel', code: 'il', dialCode: '+972', flag: 'https://flagcdn.com/il.svg' },
  { name: 'Italy', code: 'it', dialCode: '+39', flag: 'https://flagcdn.com/it.svg' },
  { name: 'Jamaica', code: 'jm', dialCode: '+1876', flag: 'https://flagcdn.com/jm.svg' },
  { name: 'Japan', code: 'jp', dialCode: '+81', flag: 'https://flagcdn.com/jp.svg' },
  { name: 'Jordan', code: 'jo', dialCode: '+962', flag: 'https://flagcdn.com/jo.svg' },
  { name: 'Kazakhstan', code: 'kz', dialCode: '+7', flag: 'https://flagcdn.com/kz.svg' },
  { name: 'Kenya', code: 'ke', dialCode: '+254', flag: 'https://flagcdn.com/ke.svg' },
  { name: 'Kiribati', code: 'ki', dialCode: '+686', flag: 'https://flagcdn.com/ki.svg' },
  { name: 'North Korea', code: 'kp', dialCode: '+850', flag: 'https://flagcdn.com/kp.svg' },
  { name: 'South Korea', code: 'kr', dialCode: '+82', flag: 'https://flagcdn.com/kr.svg' },
  { name: 'Kuwait', code: 'kw', dialCode: '+965', flag: 'https://flagcdn.com/kw.svg' },
  { name: 'Kyrgyzstan', code: 'kg', dialCode: '+996', flag: 'https://flagcdn.com/kg.svg' },
  { name: 'Laos', code: 'la', dialCode: '+856', flag: 'https://flagcdn.com/la.svg' },
  { name: 'Latvia', code: 'lv', dialCode: '+371', flag: 'https://flagcdn.com/lv.svg' },
  { name: 'Lebanon', code: 'lb', dialCode: '+961', flag: 'https://flagcdn.com/lb.svg' },
  { name: 'Lesotho', code: 'ls', dialCode: '+266', flag: 'https://flagcdn.com/ls.svg' },
  { name: 'Liberia', code: 'lr', dialCode: '+231', flag: 'https://flagcdn.com/lr.svg' },
  { name: 'Libya', code: 'ly', dialCode: '+218', flag: 'https://flagcdn.com/ly.svg' },
  { name: 'Liechtenstein', code: 'li', dialCode: '+423', flag: 'https://flagcdn.com/li.svg' },
  { name: 'Lithuania', code: 'lt', dialCode: '+370', flag: 'https://flagcdn.com/lt.svg' },
  { name: 'Luxembourg', code: 'lu', dialCode: '+352', flag: 'https://flagcdn.com/lu.svg' },
  { name: 'Madagascar', code: 'mg', dialCode: '+261', flag: 'https://flagcdn.com/mg.svg' },
  { name: 'Malawi', code: 'mw', dialCode: '+265', flag: 'https://flagcdn.com/mw.svg' },
  { name: 'Malaysia', code: 'my', dialCode: '+60', flag: 'https://flagcdn.com/my.svg' },
  { name: 'Maldives', code: 'mv', dialCode: '+960', flag: 'https://flagcdn.com/mv.svg' },
  { name: 'Mali', code: 'ml', dialCode: '+223', flag: 'https://flagcdn.com/ml.svg' },
  { name: 'Malta', code: 'mt', dialCode: '+356', flag: 'https://flagcdn.com/mt.svg' },
  { name: 'Marshall Islands', code: 'mh', dialCode: '+692', flag: 'https://flagcdn.com/mh.svg' },
  { name: 'Mauritania', code: 'mr', dialCode: '+222', flag: 'https://flagcdn.com/mr.svg' },
  { name: 'Mauritius', code: 'mu', dialCode: '+230', flag: 'https://flagcdn.com/mu.svg' },
  { name: 'Mexico', code: 'mx', dialCode: '+52', flag: 'https://flagcdn.com/mx.svg' },
  { name: 'Micronesia', code: 'fm', dialCode: '+691', flag: 'https://flagcdn.com/fm.svg' },
  { name: 'Moldova', code: 'md', dialCode: '+373', flag: 'https://flagcdn.com/md.svg' },
  { name: 'Monaco', code: 'mc', dialCode: '+377', flag: 'https://flagcdn.com/mc.svg' },
  { name: 'Mongolia', code: 'mn', dialCode: '+976', flag: 'https://flagcdn.com/mn.svg' },
  { name: 'Montenegro', code: 'me', dialCode: '+382', flag: 'https://flagcdn.com/me.svg' },
  { name: 'Morocco', code: 'ma', dialCode: '+212', flag: 'https://flagcdn.com/ma.svg' },
  { name: 'Mozambique', code: 'mz', dialCode: '+258', flag: 'https://flagcdn.com/mz.svg' },
  { name: 'Myanmar', code: 'mm', dialCode: '+95', flag: 'https://flagcdn.com/mm.svg' },
  { name: 'Namibia', code: 'na', dialCode: '+264', flag: 'https://flagcdn.com/na.svg' },
  { name: 'Nauru', code: 'nr', dialCode: '+674', flag: 'https://flagcdn.com/nr.svg' },
  { name: 'Nepal', code: 'np', dialCode: '+977', flag: 'https://flagcdn.com/np.svg' },
  { name: 'Netherlands', code: 'nl', dialCode: '+31', flag: 'https://flagcdn.com/nl.svg' },
  { name: 'New Zealand', code: 'nz', dialCode: '+64', flag: 'https://flagcdn.com/nz.svg' },
  { name: 'Nicaragua', code: 'ni', dialCode: '+505', flag: 'https://flagcdn.com/ni.svg' },
  { name: 'Niger', code: 'ne', dialCode: '+227', flag: 'https://flagcdn.com/ne.svg' },
  { name: 'Nigeria', code: 'ng', dialCode: '+234', flag: 'https://flagcdn.com/ng.svg' },
  { name: 'North Macedonia', code: 'mk', dialCode: '+389', flag: 'https://flagcdn.com/mk.svg' },
  { name: 'Norway', code: 'no', dialCode: '+47', flag: 'https://flagcdn.com/no.svg' },
  { name: 'Oman', code: 'om', dialCode: '+968', flag: 'https://flagcdn.com/om.svg' },
  { name: 'Pakistan', code: 'pk', dialCode: '+92', flag: 'https://flagcdn.com/pk.svg' },
  { name: 'Palau', code: 'pw', dialCode: '+680', flag: 'https://flagcdn.com/pw.svg' },
  { name: 'Palestine', code: 'ps', dialCode: '+970', flag: 'https://flagcdn.com/ps.svg' },
  { name: 'Panama', code: 'pa', dialCode: '+507', flag: 'https://flagcdn.com/pa.svg' },
  { name: 'Papua New Guinea', code: 'pg', dialCode: '+675', flag: 'https://flagcdn.com/pg.svg' },
  { name: 'Paraguay', code: 'py', dialCode: '+595', flag: 'https://flagcdn.com/py.svg' },
  { name: 'Peru', code: 'pe', dialCode: '+51', flag: 'https://flagcdn.com/pe.svg' },
  { name: 'Philippines', code: 'ph', dialCode: '+63', flag: 'https://flagcdn.com/ph.svg' },
  { name: 'Poland', code: 'pl', dialCode: '+48', flag: 'https://flagcdn.com/pl.svg' },
  { name: 'Portugal', code: 'pt', dialCode: '+351', flag: 'https://flagcdn.com/pt.svg' },
  { name: 'Qatar', code: 'qa', dialCode: '+974', flag: 'https://flagcdn.com/qa.svg' },
  { name: 'Romania', code: 'ro', dialCode: '+40', flag: 'https://flagcdn.com/ro.svg' },
  { name: 'Russia', code: 'ru', dialCode: '+7', flag: 'https://flagcdn.com/ru.svg' },
  { name: 'Rwanda', code: 'rw', dialCode: '+250', flag: 'https://flagcdn.com/rw.svg' },
  {
    name: 'Saint Kitts and Nevis',
    code: 'kn',
    dialCode: '+1869',
    flag: 'https://flagcdn.com/kn.svg',
  },
  { name: 'Saint Lucia', code: 'lc', dialCode: '+1758', flag: 'https://flagcdn.com/lc.svg' },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'vc',
    dialCode: '+1784',
    flag: 'https://flagcdn.com/vc.svg',
  },
  { name: 'Samoa', code: 'ws', dialCode: '+685', flag: 'https://flagcdn.com/ws.svg' },
  { name: 'San Marino', code: 'sm', dialCode: '+378', flag: 'https://flagcdn.com/sm.svg' },
  {
    name: 'Sao Tome and Principe',
    code: 'st',
    dialCode: '+239',
    flag: 'https://flagcdn.com/st.svg',
  },
  { name: 'Saudi Arabia', code: 'sa', dialCode: '+966', flag: 'https://flagcdn.com/sa.svg' },
  { name: 'Senegal', code: 'sn', dialCode: '+221', flag: 'https://flagcdn.com/sn.svg' },
  { name: 'Serbia', code: 'rs', dialCode: '+381', flag: 'https://flagcdn.com/rs.svg' },
  { name: 'Seychelles', code: 'sc', dialCode: '+248', flag: 'https://flagcdn.com/sc.svg' },
  { name: 'Sierra Leone', code: 'sl', dialCode: '+232', flag: 'https://flagcdn.com/sl.svg' },
  { name: 'Singapore', code: 'sg', dialCode: '+65', flag: 'https://flagcdn.com/sg.svg' },
  { name: 'Slovakia', code: 'sk', dialCode: '+421', flag: 'https://flagcdn.com/sk.svg' },
  { name: 'Slovenia', code: 'si', dialCode: '+386', flag: 'https://flagcdn.com/si.svg' },
  { name: 'Solomon Islands', code: 'sb', dialCode: '+677', flag: 'https://flagcdn.com/sb.svg' },
  { name: 'Somalia', code: 'so', dialCode: '+252', flag: 'https://flagcdn.com/so.svg' },
  { name: 'South Africa', code: 'za', dialCode: '+27', flag: 'https://flagcdn.com/za.svg' },
  { name: 'South Sudan', code: 'ss', dialCode: '+211', flag: 'https://flagcdn.com/ss.svg' },
  { name: 'Spain', code: 'es', dialCode: '+34', flag: 'https://flagcdn.com/es.svg' },
  { name: 'Sri Lanka', code: 'lk', dialCode: '+94', flag: 'https://flagcdn.com/lk.svg' },
  { name: 'Sudan', code: 'sd', dialCode: '+249', flag: 'https://flagcdn.com/sd.svg' },
  { name: 'Suriname', code: 'sr', dialCode: '+597', flag: 'https://flagcdn.com/sr.svg' },
  { name: 'Sweden', code: 'se', dialCode: '+46', flag: 'https://flagcdn.com/se.svg' },
  { name: 'Switzerland', code: 'ch', dialCode: '+41', flag: 'https://flagcdn.com/ch.svg' },
  { name: 'Syria', code: 'sy', dialCode: '+963', flag: 'https://flagcdn.com/sy.svg' },
  { name: 'Taiwan', code: 'tw', dialCode: '+886', flag: 'https://flagcdn.com/tw.svg' },
  { name: 'Tajikistan', code: 'tj', dialCode: '+992', flag: 'https://flagcdn.com/tj.svg' },
  { name: 'Tanzania', code: 'tz', dialCode: '+255', flag: 'https://flagcdn.com/tz.svg' },
  { name: 'Thailand', code: 'th', dialCode: '+66', flag: 'https://flagcdn.com/th.svg' },
  { name: 'Togo', code: 'tg', dialCode: '+228', flag: 'https://flagcdn.com/tg.svg' },
  { name: 'Tonga', code: 'to', dialCode: '+676', flag: 'https://flagcdn.com/to.svg' },
  {
    name: 'Trinidad and Tobago',
    code: 'tt',
    dialCode: '+1868',
    flag: 'https://flagcdn.com/tt.svg',
  },
  { name: 'Tunisia', code: 'tn', dialCode: '+216', flag: 'https://flagcdn.com/tn.svg' },
  { name: 'Turkey', code: 'tr', dialCode: '+90', flag: 'https://flagcdn.com/tr.svg' },
  { name: 'Turkmenistan', code: 'tm', dialCode: '+993', flag: 'https://flagcdn.com/tm.svg' },
  { name: 'Tuvalu', code: 'tv', dialCode: '+688', flag: 'https://flagcdn.com/tv.svg' },
  { name: 'Uganda', code: 'ug', dialCode: '+256', flag: 'https://flagcdn.com/ug.svg' },
  { name: 'Ukraine', code: 'ua', dialCode: '+380', flag: 'https://flagcdn.com/ua.svg' },
  {
    name: 'United Arab Emirates',
    code: 'ae',
    dialCode: '+971',
    flag: 'https://flagcdn.com/ae.svg',
  },
  { name: 'United Kingdom', code: 'gb', dialCode: '+44', flag: 'https://flagcdn.com/gb.svg' },
  { name: 'United States', code: 'us', dialCode: '+1', flag: 'https://flagcdn.com/us.svg' },
  { name: 'Uruguay', code: 'uy', dialCode: '+598', flag: 'https://flagcdn.com/uy.svg' },
  { name: 'Uzbekistan', code: 'uz', dialCode: '+998', flag: 'https://flagcdn.com/uz.svg' },
  { name: 'Vanuatu', code: 'vu', dialCode: '+678', flag: 'https://flagcdn.com/vu.svg' },
  { name: 'Vatican City', code: 'va', dialCode: '+379', flag: 'https://flagcdn.com/va.svg' },
  { name: 'Venezuela', code: 've', dialCode: '+58', flag: 'https://flagcdn.com/ve.svg' },
  { name: 'Vietnam', code: 'vn', dialCode: '+84', flag: 'https://flagcdn.com/vn.svg' },
  { name: 'Yemen', code: 'ye', dialCode: '+967', flag: 'https://flagcdn.com/ye.svg' },
  { name: 'Zambia', code: 'zm', dialCode: '+260', flag: 'https://flagcdn.com/zm.svg' },
  { name: 'Zimbabwe', code: 'zw', dialCode: '+263', flag: 'https://flagcdn.com/zw.svg' },
];

export default countries;
